import { render, staticRenderFns } from "./WarrantyConfig.vue?vue&type=template&id=4ae06f57&scoped=true&"
import script from "./WarrantyConfig.vue?vue&type=script&lang=js&"
export * from "./WarrantyConfig.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyConfig.vue?vue&type=style&index=0&id=4ae06f57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae06f57",
  null
  
)

export default component.exports